import statePlateImages from "../../data/statePlateImages.json";

export default function StatePlateGallery({ stateCode }) {
  const plates = statePlateImages[stateCode] || [];
  if (!plates.length) return null;

  return (
    <div className="lp-plate-gallery" aria-label="Common license plates for this state">
      {plates.map((plate) => (
        <figure key={plate.slot} className="lp-plate-card">
          <img
            src={plate.src}
            alt={`${plate.title} license plate`}
            loading="lazy"
            decoding="async"
          />
          <figcaption className="lp-plate-caption">{plate.title}</figcaption>
        </figure>
      ))}
    </div>
  );
}
